<template>
  <section class="view">
    <ViewLoader v-if="loading"/>
    <template v-else>
      <ViewHeader v-if="checkins.length">
        <template slot="title">{{ $t('pages.checkins_list.page_title') }}</template>
        <template slot="intro">{{ $t('pages.checkins_list.page_subtitle') }}</template>
      </ViewHeader>

      <div class="view-body view-body--padded" v-if="checkins.length">
        <div class="container">
          <div class="row row-double-gutters">
            <div class="col-xs-12 col-md-6 col-xl-4" v-for="checkin in checkins" :key="checkin.id">
              <CheckinsListItem :checkin="checkin" @item-clicked="openCheckinDetail($event)"
                                @anonymize="openModalAnonymize(checkin)"
                                @item-remove="openModalRemoveCheckin(checkin)"
                                @show-picacode="openModalShowPicacode(checkin)"
                                @show-qr-picacode="openModalShowQrPicacode(checkin)"
                                @download-album="downloadAlbum(checkin)"/>
            </div>
          </div>
        </div>
      </div>
      <FirstCheckinWelcome v-else/>
    </template>
    <ModalRemoveCheckin :checkin-id="selectedCheckin.id" :picacode="selectedCheckin.picacode" v-if="selectedCheckin"
                        @checkin-removed="removeCheckinFromList($event)"/>
    <ModalShowPicacode :picacode="selectedCheckin.picacode" v-if="selectedCheckin"/>
    <ModalShowQrPicacode :picacode="selectedCheckin.picacode" v-if="selectedCheckin"/>
    <ModalAnonymizeCheckin :checkin-id="selectedCheckin.id"
                           :checkin-anonymize-status="selectedCheckin.anonymize_status"
                           :checkin-event-name="selectedCheckin.pica_service.event_name"
                           :checkin-anonymize-mode="selectedCheckin.anonymize_mode"
                           @anonymize-call-back="onAnonymizeCallBack"
                           v-if="selectedCheckin"/>
  </section>
</template>


<script>
import ViewLoader from "@/components/ViewLoader"
import ViewHeader from '@/components/ViewHeader'
import CheckinsListItem from '@/components/CheckinsListItem'
import FirstCheckinWelcome from "@/components/FirstCheckinWelcome"
import ModalRemoveCheckin from "@/components/ModalRemoveCheckin"
import ModalShowPicacode from "@/components/ModalShowPicacode"
import ModalAnonymizeCheckin from "@/components/ModalAnonymizeCheckin"
import VoucherService from "@/services/Voucher"
import EventService from "@/services/Event";
import {mapGetters} from "vuex";
import {ANONYMIZATION_STATUS} from "@/components/ModalAnonymizeCheckin.vue";
import ModalShowQrPicacode from "@/components/ModalShowQrPicacode.vue";

export default {
  // metaInfo: {
  //     // if no subcomponents specify a metaInfo.title, this title will be used
  //     title: 'eventi',
  // },

  components: {
    ViewLoader,
    ViewHeader,
    CheckinsListItem,
    FirstCheckinWelcome,
    ModalRemoveCheckin,
    ModalShowPicacode,
    ModalShowQrPicacode,
    ModalAnonymizeCheckin
  },

  data() {
    return {
      loading: true,
      selectedCheckin: null,
    }
  },

  created() {
    this.ANONYMIZATION_STATUS = ANONYMIZATION_STATUS
  },

  mounted() {
    // If appConfig was already loaded => load checkin data
    if (this.getAppConfigReady) {
      this.loadCheckinListData()
    }
  },

  beforeCreate() {
    console.log('CREATED CheckinList')

    const voucher = this.$store.getters['getVoucherToReedem']
    this.$store.commit('SET_VOUCHER_TO_REEDEM', '')
    // Redeem multi-event voucher
    if (voucher) {
      VoucherService.redeemVoucher(voucher)
          .then(() => {
            setTimeout(() => this.$bvToast.toast(this.$t('modal_voucher.valid_voucher_feedback'),
                    {
                      autoHideDelay: 200000,
                      headerClass: '',
                      noCloseButton: false
                    }),
                200)
          })
    }


    //
    //     this.$store.dispatch('digitalItems/getCheckins')
    //         .then(checkins => {
    //             console.log('results', checkins)
    //
    //             const picacodes = checkins.map(checkin => {return {'code': checkin.picacode}})
    //
    //             EventService.getPhotos({
    //                 picacode: picacodes,
    //                 limit: 6
    //             }).then(photos => {
    //                 console.log('PHOTOS', photos)
    //                 // const p = photos.map(photo => (({ image_url, original_width, original_height }) => ({ image_url, original_width, original_height }))(photo))
    //                 // this.$set(this.photosByPicaCode, picacode, p)
    //             })
    //         })
    //
    //     // checkins.forEach(checkin => {
    //     //     const picacode = checkin.picacode
    //     //     EventService.getPhotos({
    //     //         pica_service: checkin.pica_service.id,
    //     //         picacode: picacode,
    //     //         limit: 6
    //     //     }).then(photos => {
    //     //         const p = photos.map(photo => (({ image_url, original_width, original_height }) => ({ image_url, original_width, original_height }))(photo))
    //     //         this.$set(this.photosByPicaCode, picacode, p)
    //     //     })
    //     // })
    //
    //     // const picacodes = checkins.map(checkin => checkin.picacode)
    // })
  },

  watch: {
    // If appConfig was NOT already loaded  => watch appConfigReady
    getAppConfigReady() {
      let ready = this.$store.getters['appConfig/getAppConfigReady']
      if (ready) {
        this.loadCheckinListData()
      }
    }
  },

  computed: {
    ...mapGetters('appConfig', [
      'getAppConfigReady'
    ]),
    checkins() {
      return this.$store.state.digitalItems.checkins
    },
  },

  methods: {
    loadCheckinListData() {

      if (!this.$store.state.appConfig.hideCart) {
        this.$store.dispatch('cart/getCart', {
          //include_only_price_summary: true  // ho dovuto caricare tutto il carrello altrimenti dava errore 'stampa le tue foto' quando selezionavo il formato
        }).then(() => {
          this.$store.dispatch('digitalItems/getCheckins').then(() => {
            this.loading = false
            this.subscribeToWebSocketCheckinEvents()
          })
        })
      } else {
        this.$store.dispatch('digitalItems/getCheckins').then(() => {
          this.loading = false
          this.subscribeToWebSocketCheckinEvents()
        })
      }
    },
    openCheckinDetail(checkinData) {
      console.log('checkinData ', checkinData)
      this.$router.push({
        name: 'checkins-detail',
        params: {picacode: checkinData.picacode, openFaceReconition: checkinData.openFaceReconition}
      })
    },
    subscribeToWebSocketCheckinEvents() {
      // Subscribe to checkin events
      this.$store.dispatch('websocket/sendMessage',
          {'type': 'checkin.subscribe', 'data': {'picacodes': this.checkins.map(i => i.picacode)}}
      )
    },
    openModalRemoveCheckin(checkin) {
      this.selectedCheckin = checkin
      // we use $nextTick to make sure that the component exists when we show the modal
      this.$nextTick(() => this.$bvModal.show('bv-modal-remove-checkin'))
    },
    openModalShowPicacode(checkin) {
      this.selectedCheckin = checkin
      this.$nextTick(() => this.$bvModal.show('bv-modal-show-picacode'))
    },
    openModalShowQrPicacode(checkin) {
      this.selectedCheckin = checkin
      this.$nextTick(() => this.$bvModal.show('bv-modal-show-qr-picacode'))
    },
    openModalAnonymize(checkin) {
      this.selectedCheckin = checkin
      this.$nextTick(() => this.$bvModal.show('modal-anonymize-checkin'))
    },
    removeCheckinFromList(checkinId) {
      this.$store.commit('digitalItems/REMOVE_CHECKIN', checkinId)
    },
    downloadAlbum(checkin) {
      EventService.downloadAlbum(checkin.id)
          .then(response => {
            this.$bvToast.toast(
                this.$t('toast_download_album.text'),
                {
                  title: this.$t('toast_download_album.title'),
                  headerClass: 'd-block pt-2',
                  noCloseButton: false,
                  autoHideDelay: 5000
                })
          })
          .catch(error => {
            if (error.response.status === 400 && error.response.data.code === 'bulk_download_not_available') {
              this.$bvToast.toast(
                  error.response.data.detail,
                  {variant: 'warning', autoHideDelay: 5000})
            }
          })
    },
    openFaceRecognitionModal(recognitionFallbackMode = false) {
      this.$store.commit('SET_PRECHECKIN_FACE_RECOGNITION_DATA', {
        checkin: {id: this.selectedCheckin.checkin_id, picacode: this.selectedCheckin.picacode},
        max_faces_count: this.selectedCheckin.max_faces_count,
        ask_face_validity_start: this.selectedCheckin.ask_face_validity_start,
        ask_face_validity_end: this.selectedCheckin.ask_face_validity_end,
        checkin_faces: this.selectedCheckin.checkin_faces,
        user_cta: this.selectedCheckin.user_cta,
        /*callback: (checkinId, newCheckinFaces, faceCheckinComplete = false) => {
          //console.log('cb ', checkinId, this.checkin.checkin_id)
          if (checkinId === this.checkin.checkin_id) {
            //if(newCheckinFaces){
            this.$set(this.checkin, 'checkin_faces', newCheckinFaces)
          }

          console.log('faceCheckinComplete', faceCheckinComplete)

          if (recognitionFallbackMode && faceCheckinComplete) {
            this.showUploadingMessage = true
          }

        }*/
      })
      this.$bvModal.show('modal-precheckinfacerecognition')
    },
    onAnonymizeCallBack({anonymizeStatus, checkinFaceMissing}) {
      //console.log({anonymizeStatus, checkinFaceMissing})
      this.selectedCheckin.anonymize_status = anonymizeStatus
      if (checkinFaceMissing) {
        this.openFaceRecognitionModal();
      }
    }
  }
}
</script>
